/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Password_MismatchInputs */

const cs_auth_password_mismatch = /** @type {(inputs: Auth_Password_MismatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hesla se neshodují.`)
};

const en_auth_password_mismatch = /** @type {(inputs: Auth_Password_MismatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passwords do not match.`)
};

/**
* | output |
* | --- |
* | "Passwords do not match." |
*
* @param {Auth_Password_MismatchInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_password_mismatch = /** @type {((inputs?: Auth_Password_MismatchInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Password_MismatchInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_password_mismatch(inputs)
	return cs_auth_password_mismatch(inputs)
});